import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-release",
  "use": "icon-soc-l1-release-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-release\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\">\r\n  <path d=\"M192 192h128v640H192V192zm512 0h128v640H704V192z\" />\r\n  <path d=\"M352 288h320v64H352V288zm0 384h320v64H352v-64z\" />\r\n  <path d=\"M480 352l32-96 32 96v224h-64V352zm-48 224h160v64H432v-64z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-release.svg
// module id = rDQi
// module chunks = 478